import { render, staticRenderFns } from "./artist.vue?vue&type=template&id=b40e1c32&scoped=true"
import script from "./artist.vue?vue&type=script&lang=js"
export * from "./artist.vue?vue&type=script&lang=js"
import style0 from "./artist.vue?vue&type=style&index=0&id=b40e1c32&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b40e1c32",
  null
  
)

export default component.exports